/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import Vue from 'vue';
import navbarSearchAndPinList from "@/layouts/components/navbar/navbarSearchAndPinList"
import themeConfig from "@/../themeConfig.js"
import colors from "@/../themeConfig.js"

import commonConfig from "@/../commonConfig.js"

//localStorage
import VueLocalStorage from 'vue-localstorage';
Vue.use(VueLocalStorage);


// /////////////////////////////////////////////
// Helper
// /////////////////////////////////////////////

const userInfosessionStorage = JSON.parse(sessionStorage.getItem("userInfo")) || {}
    // Set default values for active-user
    // More data can be added by auth provider or other plugins/packages
const getUserInfo = () => {
    let userInfo = {}

    Object.keys(userInfosessionStorage).forEach((key) => {
        if (userInfo[key] == undefined && userInfosessionStorage[key] != null) userInfo[key] = userInfosessionStorage[key]
    })

    return userInfo
}

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
    AppActiveUser: getUserInfo(),
    bodyOverlay: false,
    isVerticalNavMenuActive: true,
    mainLayoutType: themeConfig.mainLayoutType || "vertical",
    reduceButton: themeConfig.sidebarCollapsed,
    verticalNavMenuWidth: "default",
    verticalNavMenuItemsMin: false,
    scrollY: 0,
    starredPages: navbarSearchAndPinList.data.filter((page) => page.highlightAction),
    theme: themeConfig.theme || "light",
    themePrimaryColor: colors.primary,

    commonConfig: commonConfig,
    // Can be used to get current window with
    // Note: Above breakpoint state is for internal use of sidebar & navbar component
    windowWidth: null,
    language: Vue.localStorage.get('dvms-language'),
}

export default state